import { TFunction } from 'i18next';
import { ROLES } from 'types';

import { formatPhoneForSaving } from '@utils/helpers/textHelpers';
import { FORM_STEPS, ShiftFormData } from '@utils/shiftConstants';

/**
 * Get the title for the current form step
 */
export const getStepTitle = (currentStep: string, t: TFunction): string => {
  if (currentStep === FORM_STEPS.DETAILS) return t('schoolShifts.newShifts');
  if (currentStep === FORM_STEPS.CONTACTS) return t('schoolShifts.contacts');
  return t('schoolShifts.publishShiftTitle');
};

/**
 * Get the description for the current form step
 */
export const getStepDescription = (currentStep: string, t: TFunction): string | null => {
  if (currentStep === FORM_STEPS.CONTACTS) return t('schoolShifts.contactDescription');
  if (currentStep === FORM_STEPS.APROVE) return t('schoolShifts.publishShiftDescription');
  return null;
};

/**
 * Get the bottom button label based on the current form step
 */
export const getBottomButtonLabel = (currentStep: string, t: TFunction): string => {
  if (currentStep === FORM_STEPS.DETAILS || currentStep === FORM_STEPS.CONTACTS) {
    return t('next');
  }
  return t('confirm');
};

/**
 * Check if back button should be shown for the current step
 */
export const shouldShowBackButton = (currentStep: string): boolean => {
  return currentStep !== FORM_STEPS.APROVE;
};

/**
 * Process input value based on input type
 */
export const processInputValue = (
  type: string,
  value: string,
  checked: boolean,
): string | boolean => {
  return type === 'checkbox' ? checked : value;
};

/**
 * Determine if should navigate to next step or submit
 */
export const shouldNavigateToNextStep = (currentStep: string): boolean => {
  return currentStep === FORM_STEPS.DETAILS || currentStep === FORM_STEPS.CONTACTS;
};

/**
 * Determine if should navigate back or go to shifts page
 */
export const shouldNavigateBack = (currentStep: string): boolean => {
  return currentStep === FORM_STEPS.APROVE || currentStep === FORM_STEPS.CONTACTS;
};

/**
 * Prepare shift data for submission
 */
export const prepareShiftData = (
  formData: ShiftFormData,
  listingId?: string,
): ShiftFormData & { listing_id?: string } => {
  return {
    ...formData,
    contact_phone: formData.contact_phone ? formatPhoneForSaving(formData.contact_phone) : '',
    listing_id: listingId,
  };
};

/**
 * Get the path to navigate back to shifts
 */
export const getShiftsPath = (role: string = ROLES.SCHOOL): string => {
  return `/${role}/shifts`;
};
